/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, maxLength, pattern, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusCreateUploadDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusCreateUploadDtoInitialValue(): LexplusCreateUploadDto {
  return {
  uploadStagingID: null,
  externerLink: null,
  dateiname: '',
  beschreibung: null,
  uploadDokumentTypID: '',
  uploadDokumentSubTypID: '',
  tags: [],
  trotzdemAnlegen: false,
} as LexplusCreateUploadDto;
}

/**
 * Reusable Signal Forms schema for LexplusCreateUploadDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusCreateUploadDtoSchema(path: SchemaPathTree<LexplusCreateUploadDto>): void {
  required(path.dateiname);
  maxLength(path.dateiname, 255);
  pattern(path.dateiname, new RegExp("^[^<>]+$"));
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusCreateUploadDtoForm(initial?: Partial<LexplusCreateUploadDto>) {
  const model: WritableSignal<LexplusCreateUploadDto> = signal<LexplusCreateUploadDto>({
    ...getLexplusCreateUploadDtoInitialValue(),
    ...initial,
  } as LexplusCreateUploadDto);
  return { model, field: form(model, lexplusCreateUploadDtoSchema) };
}
